import { uniq } from 'lodash';
import { scaleLinear, scalePoint } from 'd3-scale';

function getScaleForData({ data, axis, width, height, getConfiguration }) {
  const isLinearScale = data
    .flatMap(series => series.data)
    .every(data => typeof data[axis] === 'number');

  return isLinearScale
    ? getLinearScale({ data, axis, width, height, getConfiguration })
    : getPointScale({ data, axis, width, height });
}

function getLinearScale({ data, axis, width, height, getConfiguration }) {
  const isXAxis = axis === 'x';

  const values = data
    .map(series => series.data.map(item => item[axis]))
    .flat()
    .filter(val => typeof val === 'number');

  const minValue = getConfiguration(
    isXAxis ? 'horizontalMinValue' : 'minValue',
    Math.min(...values)
  );

  const maxValue = getConfiguration(
    isXAxis ? 'horizontalMaxValue' : 'maxValue',
    Math.max(...values)
  );

  const range = isXAxis ? [0, width] : [height, 0];

  return scaleLinear().rangeRound(range).domain([minValue, maxValue]);
}

function getPointScale({ data, axis, width, height }) {
  const isXAxis = axis === 'x';

  const labels = uniq(
    data.flatMap(series => series.data).map(data => data[axis])
  );

  return scalePoint()
    .domain(labels)
    .range(isXAxis ? [0, width] : [height, 0]);
}

export function scatterChartScale({
  getConfiguration,
  meta,
  data,
  width,
  height,
}) {
  return {
    x: getScaleForData({
      data,
      axis: 'x',
      getConfiguration,
      width,
      height,
    }),
    y: getScaleForData({
      data,
      axis: 'y',
      getConfiguration,
      width,
      height,
    }),
  };
}
